export enum SelectoComponentEvents {
  ON_SELECTO_SELECT_END = 'on-selecto-select-end',
  ON_SELECTO_GROUP = 'on-selecto-group',
  ON_SELECTO_UNGROUP = 'on-selecto-ungroup',
  ON_SELECTO_CLONE = 'on-selecto-clone',
  ON_SELECTO_DELETE = 'on-selecto-delete',
  ON_SELECTO_CLICK_GROUP = 'on-selecto-click-group',
  ON_CLONE_AND_ADD_TO_GROUP = 'on-selecto-clone-add-to-group',
}
